export class PointStats {
    id: number;
    rodeoEventRunId: number;

    pointSeriesId: number;
    pointAssignmentId: number;
    payoutConfigId: number;

    leaderCategory: string;
    place: number;
    points: number;
    rider2Points: number;
    bonusPointsIncluded: number;

}


// WEBPACK FOOTER //
// ./src/model/point-stats.ts